import React from 'react'

import { initialState, UIPaginationStateReducer, Actions } from './reducer'

const UIPaginationStateContext = React.createContext(null)

const UIPaginationStateProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(
    UIPaginationStateReducer,
    initialState
  )

  const update = React.useCallback((key, total, paginated, visible) => {
    dispatch({ type: Actions.UPDATE, key, total, paginated, visible })
  }, [])

  const move = React.useCallback((key, forward) => {
    dispatch({ type: Actions.CHANGE_PAGE, key, forward })
  }, [])

  const reset = React.useCallback(key => {
    dispatch({ type: Actions.RESET, key })
  }, [])

  const moveTo = React.useCallback((key, index) => {
    dispatch({ type: Actions.MOVE_TO, key, index })
  }, [])

  return (
    <UIPaginationStateContext.Provider
      value={{ state, update, move, reset, moveTo }}
    >
      {children}
    </UIPaginationStateContext.Provider>
  )
}

export default UIPaginationStateProvider

export const useUIPaginationState = () =>
  React.useContext(UIPaginationStateContext)
